import {isSet} from 'lodash';
import {isObject} from 'util';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

@Injectable()
export class SetSerializerInterceptor implements HttpInterceptor {
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.body) {
            this.convertSetToArrayRecursively(request.body);
            request = request.clone({body: request.body});
        }
        return next.handle(request);
    }

    private convertSetToArrayRecursively(object: object) {
        Object.keys(object).filter(key => isSet(object[key]))
            .forEach(key => object[key] = Array.from(object[key]));
        Object.keys(object).filter(key => isObject(object[key]))
            .forEach(key => this.convertSetToArrayRecursively(object[key]));
    }
}